export default __webpack_public_path__ + "static/media/millions-text.b91a277d.svg";